import React from "react";

import shallow from "zustand/shallow";

import {
    Item,
    ItemContainer,
    SubItem,
} from "../../../TechnicShop/components/GroupTreeItem";
import {
    Container,
    Wrapper,
} from "../../../TechnicShop/components/SideNavigation";
import Search from "../../DataControl/Search";
import useStore, { iShopwareCategory } from "../../store";

interface iProps {
    categories: iShopwareCategory[];
    selectedCategory?: string;
    onClick: (category: iShopwareCategory) => void;
    isSub?: boolean;
}

const CategoryTabs = ({
    categories,
    selectedCategory,
    onClick,
    isSub = false,
}: iProps) => {
    const ItemElement = isSub ? SubItem : Item;

    const { setSearch, search } = useStore(
        (state) => ({
            setSearch: state.setSearch,
            search: state.search,
        }),
        shallow
    );

    const onSearch = (search: string) => {
        if (search === "" && categories.length > 0 && !selectedCategory) {
            onClick(categories[0]);
        }
        setSearch(search);
    };

    return (
        <Wrapper>
            <Container>
                <Search onSearch={onSearch} searchTerm={search} />
                {categories.map((category) => (
                    <ItemContainer
                        className={isSub ? "sub" : ""}
                        key={category.id}
                    >
                        <ItemElement
                            isActive={selectedCategory === category.id}
                            onClick={() => onClick(category)}
                            className={
                                selectedCategory === category.id ? "active" : ""
                            }
                        >
                            {category.name}
                        </ItemElement>
                    </ItemContainer>
                ))}
            </Container>
        </Wrapper>
    );
};

export default CategoryTabs;
